export interface PhoneConfig {
	prefix: string
	label: string
	labelEn: string
	pattern: RegExp
}

// 各地区省份选项 - 统一使用英文，简化配置
const PROVINCE_CONFIGS: Record<string, string[]> = {
	GB: ["England", "Scotland", "Wales", "Northern Ireland"],
	HK: ["Hong Kong Island", "Kowloon", "New Territories"],
	TW: [
		"Taipei City",
		"New Taipei City",
		"Taoyuan City",
		"Taichung City",
		"Tainan City",
		"Kaohsiung City",
		"Keelung City",
		"Hsinchu City",
		"Chiayi City",
		"Hsinchu County",
		"Miaoli County",
		"Changhua County",
		"Nantou County",
		"Yunlin County",
		"Chiayi County",
		"Pingtung County",
		"Yilan County",
		"Hualien County",
		"Taitung County",
		"Penghu County",
		"Kinmen County",
		"Lienchiang County",
	],
	MO: ["Macau Peninsula", "Taipa", "Cotai", "Coloane"],
}

// 根据地区代码获取省份选项（静态配置，统一使用英文）
export const getProvinceOptions = (areaCode: string | undefined): string[] => {
	if (!areaCode) return []

	const config = PROVINCE_CONFIGS[areaCode]
	if (!config) return []

	return config
}

// 手机号前缀配置
export const phoneConfigs: Record<string, PhoneConfig> = {
	GB: {
		prefix: "+44",
		label: "英國",
		labelEn: "United Kingdom",
		pattern: /^[0-9]{8,15}$/,
	},
}

// 地区名称配置
export const areaNames: Record<string, { zh: string; en: string }> = {
	GB: { zh: "英國", en: "United Kingdom" },
}

// 获取手机号配置的辅助函数
export const getPhoneConfig = (
	areaCode: string | undefined,
): PhoneConfig | null => {
	if (!areaCode) return null
	return phoneConfigs[areaCode] || null
}

// 获取地区名称的辅助函数
export const getAreaName = (
	areaCode: string | undefined,
	locale: string = "zh",
): string => {
	if (!areaCode) return ""
	const area = areaNames[areaCode]
	if (!area) return ""
	return locale === "en" ? area.en : area.zh
}
